"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sloveniaTranslations = void 0;
var _types = require("../../../types");
const sloveniaTranslations = exports.sloveniaTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Oprostite!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Nazaj',
  [_types.ErrorPageTranslationKey.text]: 'Stran trenutno ni na voljo',
  [_types.ErrorPageTranslationKey.notFound]: 'Stran, ki jo poskušate odpreti, ne deluje',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Stran, ki jo želite odpreti, je omejena in niso izpolnjena vsa merila.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Obrnite se na skupino za podporo Oriflame po e-pošti:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Zahtevani URL je bil zavrnjen!'
};
